export default __webpack_public_path__ + "static/media/sa2.42b12a9f.jpg";